/**
 * Flags API Endpoints
 *
 * Flags are scoped per-instrument and identified by a string `code`.
 */

export const FLAGS_ENDPOINTS = {
  /** GET — list flags for an instrument, POST — create. */
  FLAGS: (instrumentId: number) => `/instruments/${instrumentId}/flags`,

  /** GET — single flag by code. */
  FLAG_BY_CODE: (instrumentId: number, code: string) =>
    `/instruments/${instrumentId}/flags/${encodeURIComponent(code)}`,

  /** PUT — update flag by code. */
  UPDATE_FLAG: (instrumentId: number, code: string) => `/instruments/${instrumentId}/flags/${encodeURIComponent(code)}`,

  /** DELETE — remove flag by code. */
  DELETE_FLAG: (instrumentId: number, code: string) => `/instruments/${instrumentId}/flags/${encodeURIComponent(code)}`,
} as const;
